import { Grid } from "@material-ui/core";
import { Typography } from "@mui/material";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { ReactComponent as DeleteIcon } from "../../assets/DeleteIcon.svg";
import DialogBox from "../../components/DialogBoxComponent/DialogBox";
import Toast from "../../components/ToastContainer/CustomToast";
import { deleteBlackListType } from "../../slices/BlacklistType/BlacklistTypeSlice";
import { ThemeContext } from "../../theme/ThemeContext";

export default function DeleteBlacklistType(props) {
  const { open, handleClose } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { darkMode } = useContext(ThemeContext);
  const handleSubmit = () => {
    const payload = {
      id: props.DeleteId,
      name: props?.blackListType?.name,
      description: props?.blackListType?.description,
    };

    dispatch(deleteBlackListType(payload))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0062") {
          Toast(data.message, "success");
          props.delete();
          handleClose();
        } else {
          Toast(data.message, "error");
          handleClose();
        }
      })
      .catch((er) => { });
  };

  return (
    <>
      <DialogBox
        Header={
          <span style={{ fontSize: "21px", color: darkMode ? "#fff" : "" }}>
            {t("COMMON004")}
          </span>
        }
        acceptText={t("confirmVisitorButton")}
        cancelText={t("dataTableCancel")}
        fullWidth={true}
        onClose={() => handleClose(false)}
        cancel={handleClose}
        onSubmit={handleSubmit}
        open={open}
      >
        <Grid
          container
          justifyContent="center"
          direction="column"
          alignItems={"center"}
          style={{
            backgroundColor: darkMode ? "#0E2A41" : "",
          }}
        >
          <Grid>
            <DeleteIcon width="60px" height={"50px"} />
          </Grid>
          <Grid>
            <Grid
              style={{
                wordWrap: "break-word",
                opacity: 1,
                textAlign: "center",
                display: "flex",
                flexDirection: "row",
                fontSize: "17px",
                marginTop: "15px",
              }}
            >
              <Typography
                style={{
                  color: darkMode ? "#fff" : "#242424",
                  marginRight: "4px",
                  fontSize: "17px",
                }}
              >
                {t("COMP0015")}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </DialogBox>
    </>
  );
}
